import React from 'react';
import { Select, MenuItem } from '@material-ui/core';

const DistrGpSelector = ({ selectValue, onChangeFunc, distrGroup }) => {
    return (
        <Select value={selectValue} onChange={onChangeFunc}>
            <MenuItem key={'distrGpNull'} value={'default'}>
                Please Select
            </MenuItem>
            {Object.keys(distrGroup)
                .sort(function (a, b) {
                    var textA = distrGroup[a].distr_group_name.toUpperCase();
                    var textB = distrGroup[b].distr_group_name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                })
                .map((key) => {
                    const { distr_group_id, distr_group_name } = distrGroup[key];
                    if (distr_group_name.toLowerCase() === 'all') return;
                    return (
                        <MenuItem key={'form' + 'distrGp' + distr_group_id} value={distr_group_id}>
                            {distr_group_name}
                        </MenuItem>
                    );
                })}
        </Select>
    );
};

export default DistrGpSelector;
